module.exports = __webpack_public_path__ + "img/xhs.99ec0ad8.png";